<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['dischargepatient']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-deathcertificate size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Certificate</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :busy="IsBusy"
                show-empty
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>Loading data...</strong></div></template>
              <template #empty><div class="text-center text-muted my-3"><strong>No data found</strong></div></template>
              <template #cell(index)="data">
                {{ ((currentPage - 1) * perPage) + data.index + 1 }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(patientid)="data">
                {{ data.item.patient.patient_id }}
              </template>
              <template #cell(patientct)="data">
                0{{ data.item.patient.telephone }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <router-link :to="{ path: '/printdeathcertificate', query: { id:data.item.id, }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link>
                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Death Certificates</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-deathcertificate" centered title="New Certificate" title-class="font-18" hide-footer>
        <form @submit.prevent="addCertificate">
          <div class="form-group mb-2">
            <label>Patient's Name</label>
              <multiselect v-model="patient" :options="visits" :custom-label="customLabel" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Date of Death</label>
            <input v-model="date_of_death" type="date" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Cause of Death</label>
              <textarea v-model="cause" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-deathcertificate')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-deathcertificate" centered title="Delete Certificate " title-class="font-18" hide-footer>
        <form @submit.prevent="removeCertificate">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Certificate for : <b>{{ patient }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-deathcertificate')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {deathcertificateMethods, visitMethods, deathcertificateComputed, visitComputed } from "@/state/helpers";

export default {
  page: {
    title: "Death Certificates",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Multiselect,Layout,PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Death Certificates",
      items: [ {text: "Dashboard",to: "/",}, {text: "Death Certificates",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'patientid', label: 'Patient ID', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'date_of_death', label: 'Date of Death', visible: true },
          { key: 'cause', label: 'Cause', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient:'',
      cause:'',
      date_of_death:new Date().toLocaleDateString('fr-CA'),
    };
  },
  computed: {
    ...deathcertificateComputed,
    ...visitComputed,
    List() { return this.TotalRows; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.deathcertificates.map((d) => ({...d }))},
    IsBusy() { return this.isBusy; },
  },
  mounted() {
    this.loadDeathCertificates();
    this.fetchVisits();
  },
  watch: {
    currentPage() {
      this.loadDeathCertificates();
    },
    perPage() {
      this.currentPage = 1;
      this.loadDeathCertificates();
    },
    filter() {
      this.currentPage = 1;
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.loadDeathCertificates();
      }, 300);
    },
  },
  methods: {
    ...deathcertificateMethods,
    ...visitMethods,
    customLabel ({ patient_id, name, telephone }) {
      return `${patient_id} – ${name} – ${telephone}`
    },
    async loadDeathCertificates() {
      this.isBusy = true;
      const response = await this.fetchDeathCertificates({
        page: this.currentPage,
        per_page: this.perPage,
        search: this.filter || "",
      });
      this.TotalRows = response.data.pagination?.total || 0;
      this.isBusy = false;
    },
    remove(id,patient){
      this.id=id;
      this.patient=patient;
      this.$bvModal.show('delete-deathcertificate')
    },
    async addCertificate() { 
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("date_of_death", this.date_of_death);
      formData.append("cause", this.cause);
      let url = "/adddeathcertificate";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchDeathCertificates();
        this.fetchVisits();
        this.$bvModal.hide('new-deathcertificate');
        this.patient="";
        this.date_of_death="";
        this.$toast.success("New Patient Certificate Added");
      }
      });
    },
   
    async removeCertificate() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removedeathcertificate";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchDeathCertificates();
        this.$bvModal.hide('delete-deathcertificate');
        this.$toast.error("Patient Certificate Deleted");
      }
    });
    },
  },
};
</script>
